var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "21px",
    viewBox: "0 0 15 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Walking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Walking",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.72916,10.41666 C0.72916,10.41666 1.56249,9.16666 2.18749,8.22916 C2.60416,7.60416 3.12499,7.18749 3.85416,6.97916 L6.04166,6.35416 C7.29166,6.04166 8.54166,6.66666 8.95836,7.81249 L9.58336,9.16666 C9.89586,9.99996 10.52086,10.52086 11.35416,10.83336 L13.22916,11.45836",
    id: "Path",
    stroke: "#444444",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02086,4.16667 C9.17146,4.16667 10.10416,3.23393 10.10416,2.08334 C10.10416,0.93274 9.17146,4.4408921e-16 8.02086,4.4408921e-16 C6.87026,4.4408921e-16 5.93746,0.93274 5.93746,2.08334 C5.93746,3.23393 6.87026,4.16667 8.02086,4.16667 Z",
    id: "Path",
    fill: "#444444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52086,6.35416 L4.47916,11.14586 C4.27082,11.87496 4.58336,12.60416 4.99996,13.12496 L8.54166,16.97916 L7.49996,12.08336 L8.43746,7.81249 L7.70836,6.35416 L5.52086,6.35416 L5.52086,6.35416 Z",
    id: "Path",
    fill: "#444444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68746,20.83336 L11.87496,20.83336 C11.45836,19.79166 10.41666,17.18746 9.99996,15.93746 L6.97916,11.56246 L5.31246,12.81246 L8.12496,16.56246 L9.68746,20.83336 Z",
    id: "Path",
    fill: "#444444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#444444",
    fillRule: "nonzero",
    points: "2.39584 20.83336 4.79166 18.12496 5.62496 15.62496 4.0625 13.85416 3.125 16.87496 0 20.83336"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalking);
export default __webpack_public_path__ + "static/media/Walking.acc358bc.svg";
export { ForwardRef as ReactComponent };